import React from 'react'
import "./color.css"

function GreenUL() {
    var x = localStorage.getItem("percentage ulp")
    return (
        <div className = "green__backgroundul">
            {x == "NaN" ? "null": x} %
        </div>
    )
}

export default GreenUL
